import axios from "axios";
import errorHandler from "./errorHandler";
import successHandler from "./successHandler";
import storePersist from "./../redux/storePersist";
import getRequestURl from "./requester";

export let tenantDetails = {
  SalesChannelName: "",
  StoreId: "",
  SalesChannelId: "",
  CountryCode: "",
  CurrencyCode: "",
  LanguageCode: "",
};
const request = {
  create: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
        

          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessToken")?.current?.JwtToken
                ? storePersist?.get("accessToken")?.current?.JwtToken
                : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  read: async ({ url, entity }) => {
  
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.get(url, {
        method: "GET",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
   

          Authorization:
          "Bearer " +
          `${
            storePersist?.get("accessToken")?.current?.JwtToken
              ? storePersist?.get("accessToken")?.current?.JwtToken
              : guestToken
          }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  update: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.put(url, jsonData, {
        method: "PUT",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
      
          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessToken")?.current?.JwtToken
                ? storePersist?.get("accessToken")?.current?.JwtToken
                : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  delete: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
     
          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessToken")?.current?.JwtToken
                ? storePersist?.get("accessToken")?.current?.JwtToken
                : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  summary: async ({ url, jsonData, entity, options = { limit: 5 }  }) => {
    const guestToken = localStorage.getItem("guest-token");
    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
     
          Authorization:
            "Bearer " +
            `${
              storePersist?.get("accessToken")?.current?.JwtToken
                ? storePersist?.get("accessToken")?.current?.JwtToken
                : guestToken
            }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  query: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      // let query = "?";
      // for (var key in options) {
      //   query += key + "=" + options[key] + "&";
      // }
      // query = query.slice(0, -1);

      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
    
          Authorization:
          "Bearer " +
          `${
            storePersist?.get("accessToken")?.current?.JwtToken
              ? storePersist?.get("accessToken")?.current?.JwtToken
              : guestToken
          }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
  list: async ({ url, jsonData, entity, options = { limit: 5 } }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;
      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      // let query = "?";
      // for (var key in options) {
      //   query += key + "=" + options[key] + "&";
      // }
      // query = query.slice(0, -1);

      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "application/json",
          Authorization:
          "Bearer " +
          `${
            storePersist?.get("accessToken")?.current?.JwtToken
              ? storePersist?.get("accessToken")?.current?.JwtToken
              : guestToken
          }`,
        },
        // redirect: 'follow',
        referrerPolicy: "no-referrer",
      });

      successHandler(response, {
        notifyOnSuccess: false,
        notifyOnFailed: true,
      });

      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
 
  uploadCreate: async ({ url, jsonData, entity }) => {
    const guestToken = localStorage.getItem("guest-token");

    if (storePersist?.get("channels")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;

      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    if (storePersist?.get("metaTokenMetaData")?.isSuccess) {
      var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
      tenantDetails.CountryCode =
        metaTokenMetaData.CountryCode;
      tenantDetails.CurrencyCode =
        metaTokenMetaData.CurrencyCode;
      tenantDetails.LanguageCode =
        metaTokenMetaData.LanguageCode;
    }
    if (storePersist.get("userProfile")?.isSuccess) {
      var channelsList = storePersist?.get("channels")?.current;
      const specificChannel = channelsList?.find(
        (element) => element.SalesChannelName === "Portal"
      );
      tenantDetails.SalesChannelName = "Platform";
      tenantDetails.StoreId = specificChannel?.StoreId;
      tenantDetails.SalesChannelId = specificChannel?.Id;
    }

    try {
      const response = await axios.post(url, jsonData, {
        method: "POST",
        mode: "no-cors",
        cache: "no-cache",
        credentials: "include",
        headers: {
          "Content-Type": "multipart/form-data",
          Channel: tenantDetails?.SalesChannelName || "Platform",
          StoreId: tenantDetails?.StoreId || null,
          SalesChannelId: tenantDetails?.SalesChannelId || null,
          CountryCode: tenantDetails?.CountryCode || null,
          CurrencyCode: tenantDetails?.CurrencyCode || null,
          LanguageCode: tenantDetails?.LanguageCode || null,
          Accept: "multipart/form-data",
      

          Authorization:
          "Bearer " +
          `${
            storePersist?.get("accessToken")?.current?.JwtToken
              ? storePersist?.get("accessToken")?.current?.JwtToken
              : guestToken
          }`,
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
      });
      successHandler(response, {
        notifyOnSuccess: true,
        notifyOnFailed: true,
      });
      return response;
    } catch (error) {
      return errorHandler(error);
    }
  },
};

export default request;
